import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  PlayCircle,
  ShieldCheck,
  Sparkle,
  CaretDown,
} from "@phosphor-icons/react";
import { HeroLiveWidget } from "./HeroLiveWidget";
import { useLandingT } from "@/lib/landingI18n";
import { LANDING } from "@/constants/landingTestIds";

export const HeroSection = ({ lang }) => {
  const t = useLandingT(lang);

  return (
    <section className="relative pt-12 md:pt-20 pb-20 md:pb-28">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-6 text-start">
          <div className="kicker">
            <span className="dot" />
            {t("announce")}
          </div>

          <p className="mt-6 text-emerald-300/90 text-xs uppercase tracking-[0.24em] font-medium">
            {t("heroKicker")}
          </p>

          <h1 className="h-mega mt-3 text-white">
            {t("heroTitle1")}{" "}
            <span className="neon-text italic font-medium">
              {t("heroTitleProfit")}
            </span>{" "}
            {t("heroTitle2")}
          </h1>

          <p className="mt-6 text-slate-300 text-base md:text-lg max-w-xl leading-relaxed">
            {t("heroSubtitle")}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              data-testid={LANDING.heroCta}
              to="/app"
              className="btn-neon inline-flex items-center gap-2 px-6 py-3.5 rounded-xl text-sm md:text-base"
            >
              {t("heroCta")}
              <ArrowRight size={16} weight="bold" className="flip-x" />
            </Link>
            <a
              data-testid={LANDING.heroCta2}
              href="#how"
              className="btn-ghost-light inline-flex items-center gap-2 px-5 py-3.5 rounded-xl text-sm md:text-base"
            >
              <PlayCircle size={18} weight="duotone" />
              {t("heroCta2")}
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-4 text-xs text-slate-400">
            <div className="flex items-center gap-2">
              <ShieldCheck size={16} weight="duotone" className="text-emerald-400" />
              No card needed
            </div>
            <div className="w-px h-4 bg-white/10" />
            <div className="flex items-center gap-2">
              <Sparkle size={14} weight="duotone" className="text-emerald-400" />
              {t("heroTrust")}
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <HeroLiveWidget lang={lang} />
        </div>
      </div>

      <div className="hidden md:flex justify-center mt-12 opacity-70">
        <div className="flex flex-col items-center gap-2 text-slate-500 text-[10px] uppercase tracking-[0.24em]">
          Scroll
          <CaretDown size={14} weight="bold" className="animate-bounce text-slate-500" />
        </div>
      </div>
    </section>
  );
};
